import {IconButton} from '@mui/material';
import {CloseOutlined} from '@mui/icons-material';
import {useTheme} from '@mui/material/styles';
import type {CloseButtonProps} from 'react-toastify';

export function CloseButton({ closeToast }: CloseButtonProps) {
    const theme = useTheme();

    return (
        <IconButton
            onClick={closeToast}
            aria-label="close"
            sx={{ color: theme.palette.primary.main, ml: '0.4em', width: 'fit-content', height: 'fit-content' }}
            size="small"
        >
            <CloseOutlined/>
        </IconButton>
    );
}
